export function isAggregateColumnNameTaken(
  columnName,
  availableColumns,
  existingAggregateColumns,
  initialColumnName
) {
  if (!columnName) return false;
  const lcColName = columnName.trim().toLowerCase();
  const taken = (name) => name && name.trim().toLowerCase() === lcColName;
  const bothTaken = (c) => taken(c.displayName) || taken(c.internalName);
  if (initialColumnName && taken(initialColumnName)) return false;
  if ((availableColumns ?? []).some((c) => bothTaken(c))) return true;
  return (existingAggregateColumns ?? []).some((c) => bothTaken(c));
}

export function isAddAggregateSaveDisabled(
  columnName,
  isNameTaken,
  expression,
  isExpressionValidFn
) {
  return !(columnName ?? "") || isNameTaken || !isExpressionValidFn(expression);
}
